(function ($) {
  var elementorHookRegistered = false;
  var tooltipOptions = {
    html: true,
    trigger: 'hover focus',
    delay: {show: 100, hide: 1000},
    container: 'body'
  };

  function getTooltipTriggers($scope) {
    if ($scope.is('[data-bs-toggle="tooltip"]')) {
      return $scope;
    }

    return $scope.find('[data-bs-toggle="tooltip"]');
  }

  function initTooltips($scope) {
    if (!window.bootstrap || !window.bootstrap.Tooltip) {
      return;
    }

    getTooltipTriggers($scope).each(function () {
      window.bootstrap.Tooltip.getOrCreateInstance(this, tooltipOptions);
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;
    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/single-formation-banner.default',
      initTooltips
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();
    initTooltips($(document));
  });
})(jQuery);
